import React from 'react'
import './InventoryImages.css'


function ImagePreview(props) {
    // console.log("Image Preview props", props)



    const toggleSelected = () => {
        props.onImageSelect(props.image)
    }


    if (!!props.image) {
        const source = URL.createObjectURL(props.image)

        const onPreviewLoad = (src) => {
            URL.revokeObjectURL(src) // free memory
        }

        return (
            <div className={` ${props.isImageSelected ? 'border-selected' : 'border-not-selected'}`} onClick={toggleSelected}>
                <div className='rel'>
                <img 
                    src={source} 
                    className='inventory-thumb-image'
                    onLoad={() => onPreviewLoad(source)}
                /> 

                    <div className={props.overlayTextClassName}>
                        <h3>{props.overlayText}</h3>
                    </div>

                </div>
            </div>
        )
    } else {
        return null
    }
}

export default ImagePreview
